import { toast } from 'sonner'
import { trpc } from '@/config/trpc'
import { trackConnectorConnectStarted } from '@/lib/analytics/connectionTracking'
import { startGoogleCalendarAuth } from '@/lib/auth/google-calendar'
import { Button } from '@/components/ui/shadcn/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/shadcn/card'
import { DisconnectConnectionDialog } from './disconnect-connection-dialog'

// Brand-level Google Calendar connection. Read-only source of upcoming events (launches,
// talks, trade fairs). Which calendars the agent may read is chosen per moodboard.
export function GoogleCalendarConnectionCard() {
  const { data: config } = trpc.brandConnection.googleCalendarConfig.useQuery()
  const { data: connections } = trpc.brandConnection.list.useQuery()

  const calendar = connections?.find((c) => c.provider === 'google_calendar')
  const meta = calendar?.metadata as { accountEmail?: string } | undefined

  const handleConnect = () => {
    if (!config?.clientId) {
      toast.error('Google Calendar is not configured for this environment')
      return
    }
    trackConnectorConnectStarted('google_calendar', !!calendar)
    startGoogleCalendarAuth({ clientId: config.clientId, referrerPath: window.location.pathname })
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Google Calendar</CardTitle>
        <CardDescription>
          Upcoming events like launches, talks and trade fairs. You pick the calendars on a
          moodboard. Read-only, and attendees are never read.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-4 rounded-lg border p-4">
          <div className="min-w-0">
            {config?.configured === false ? (
              <p className="text-muted-foreground text-sm">Not configured for this environment.</p>
            ) : calendar ? (
              <p className="text-foreground truncate text-sm">
                Connected{meta?.accountEmail ? ` as ${meta.accountEmail}` : ''}
              </p>
            ) : (
              <p className="text-muted-foreground text-sm">Not connected.</p>
            )}
          </div>
          {calendar ? (
            <div className="flex shrink-0 items-center gap-2">
              {/* Reconnecting re-runs consent, which is also how you switch Google accounts. */}
              <Button
                variant="outline"
                onClick={handleConnect}
                disabled={config?.configured === false}>
                Reconnect
              </Button>
              <DisconnectConnectionDialog provider="google_calendar">
                <Button variant="ghost">Disconnect</Button>
              </DisconnectConnectionDialog>
            </div>
          ) : (
            <Button onClick={handleConnect} disabled={config?.configured === false}>
              Connect
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
